// Kixz başlangıç tasarımlarındaki ürünler — kixz.com 22 Eki 2026 anlık görüntüsü (fiyatlar stüdyoda güncellenebilir)
const PR = {
 "SF10_ACA": {
  "title": "Mercurial Superfly 10 Academy NU3 FG/MG Krampon",
  "color": "Bordo",
  "brand": "Nike",
  "url": "https://kixz.com/zoom-mercurial-superfly-10-academy-nu3-fg-mg-krampon-bordo-io8441-661",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/aec464e3-1b80-4dbf-b029-9dc62e690276/image_1080.webp",
  "price": 3849.3,
  "listPrice": 5499.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8441-661_0_600.jpg"
 },
 "SF10_ELI": {
  "title": "Mercurial Superfly 10 Elite NU3 FG Krampon",
  "color": "Bordo",
  "brand": "Nike",
  "url": "https://kixz.com/zoom-mercurial-superfly-10-elite-nu3-fg-krampon-bordo-io8438-661",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/c51f51ce-99b5-4ce5-ac64-0f6746d52be8/image_1080.webp",
  "price": 14449.15,
  "listPrice": 16999.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8438-661_0_600.jpg"
 },
 "SF11_ELI": {
  "title": "Mercurial Superfly 11 Elite FG Krampon",
  "color": "Beyaz",
  "brand": "Nike",
  "url": "https://kixz.com/zoom-mercurial-superfly-11-elite-fg-krampon-beyaz-if8507-101",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/c8c3004b-ba11-4dc3-9317-26160f76af3d/image_1080.webp",
  "price": 16999.0,
  "listPrice": null,
  "jpgWide": "https://api.glowytics.com/pixel/kixz-email/img/IF8507-101_0_1200.jpg"
 },
 "VP16_ELI": {
  "title": "Mercurial Vapor 16 Elite NU3 FG Krampon",
  "color": "Bordo",
  "brand": "Nike",
  "url": "https://kixz.com/zoom-mercurial-vapor-16-elite-nu3-fg-krampon-bordo-io8442-661",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/88ccb11e-d622-42c5-958c-be0f761b8767/image_1080.webp",
  "price": 13599.15,
  "listPrice": 15999.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8442-661_0_600.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/kixz-email/img/IO8442-661_0_1200.jpg"
 },
 "VP16_ACA": {
  "title": "Mercurial Vapor 16 Academy AG Krampon",
  "color": "Mavi",
  "brand": "Nike",
  "url": "https://kixz.com/mercurial-vapor-16-academy-ag-krampon-mavi-fq8364-446",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/f32a7be9-eec4-4d08-9f05-19e878db4e03/image_1080.webp",
  "price": 3249.35,
  "listPrice": 4999.0,
  "jpgWide": "https://api.glowytics.com/pixel/kixz-email/img/FQ8364-446_0_1200.jpg"
 },
 "SF10_LV8": {
  "title": "Mercurial Superfly 10 Elite LV8 FG Krampon",
  "color": "Turuncu",
  "brand": "Nike",
  "url": "https://kixz.com/mercurial-superfly-10-elite-lv8-fg-krampon-turuncu-io8215-850",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/4b483366-c5bc-4c74-86dc-486e8d03bf81/image_1080.webp",
  "price": 11899.3,
  "listPrice": 16999.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8215-850_0_600.jpg"
 },
 "PH6_ELI": {
  "title": "Phantom 6 Low Elite NU3 FG Krampon",
  "color": "Bordo",
  "brand": "Nike",
  "url": "https://kixz.com/phantom-6-low-elite-nu3-fg-krampon-bordo-io8444-661",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/75e1c5d1-99f0-4657-b196-e714f29971fb/image_1080.webp",
  "price": 10399.35,
  "listPrice": 15999.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8444-661_0_600.jpg"
 },
 "TM_ELI": {
  "title": "Tiempo Maestro Elite NU3 FG Krampon",
  "color": "Bej",
  "brand": "Nike",
  "url": "https://kixz.com/tiempo-maestro-elite-nu3-fg-krampon-bej-io8457-201",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/c888773e-2b48-47f9-9ad1-7f8550f14d63/image_1080.webp",
  "price": 11249.25,
  "listPrice": 14999.0
 },
 "PRED_ELI": {
  "title": "Predator Elite FG Krampon",
  "color": "Mavi",
  "brand": "adidas",
  "url": "https://kixz.com/predator-elite-fg-krampon-mavi-js0432",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/a03e5d6a-d3d6-44c2-9391-77485f3852d5/image_1080.webp",
  "price": 8909.45,
  "listPrice": 16199.0
 },
 "F50_ELI": {
  "title": "F50 Hyperfast Elite FG Krampon",
  "color": "Pembe",
  "brand": "adidas",
  "url": "https://kixz.com/f50-hyperfast-elite-fg-krampon-pembe-jr5386",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/8da3153e-6a04-4420-93d0-7851fd3da35f/image_1080.webp",
  "price": 13761.75,
  "listPrice": 18349.0
 },
 "SHIN": {
  "title": "Mercurial Lite Tekmelik",
  "color": "Siyah",
  "brand": "Nike",
  "url": "https://kixz.com/mercurial-lite-tekmelik-siyah-dn3611-010",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/d50c8977-976b-4205-b59e-4615f177938f/image_1080.webp",
  "price": 2099.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/DN3611-010_0_600.jpg"
 },
 "SOCK": {
  "title": "Strike Çorap",
  "color": "Beyaz",
  "brand": "Nike",
  "url": "https://kixz.com/strike-corap-beyaz-fz8485-100",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/a347b3e2-c309-47b6-8588-fd39b6daad39/image_1080.webp",
  "price": 849.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/FZ8485-100_0_600.jpg"
 },
 "GRIP": {
  "title": "Grip Vapor Strike Kaydırmaz Çorap",
  "color": "Siyah",
  "brand": "Nike",
  "url": "https://kixz.com/grip-vapor-strike-kaydirmaz-corap-siyah-dh6613-010",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/5a63e29f-d5de-43e7-bc4c-0417205aea0a/image_1080.webp",
  "price": 1849.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/DH6613-010_0_600.jpg"
 },
 "BALL": {
  "title": "Academy Elite FA25 Futbol Topu",
  "color": "Beyaz",
  "brand": "Nike",
  "url": "https://kixz.com/academy-elite-fa25-futbol-topu-beyaz-hv6267-100",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/6418f8ef-4051-4567-9f48-2ca09e543975/image_1080.webp",
  "price": 3059.15,
  "listPrice": 3599.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/HV6267-100_0_600.jpg"
 },
 "MUNDIAL": {
  "title": "Mundial Team Halı Saha Ayakkabısı",
  "color": "Siyah",
  "brand": "adidas",
  "url": "https://kixz.com/mundial-team-hali-saha-ayakkabisi-siyah-019228",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/626dffdd-f3e3-4620-af71-10ecfaf26312/image_1080.webp",
  "price": 8159.15,
  "listPrice": 9599.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/019228_0_600.jpg"
 },
 "PH6_TF": {
  "title": "Phantom 6 Low Academy TF Halı Saha Ayakkabısı",
  "color": "Mavi",
  "brand": "Nike",
  "url": "https://kixz.com/phantom-6-low-academy-tf-hali-saha-ayakkabisi-mavi-hq2325-446",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/0843cac8-016c-4b0e-af12-4733b12ab8f2/image_1080.webp",
  "price": 2999.4,
  "listPrice": 4999.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/HQ2325-446_0_600.jpg"
 },
 "PRED_TF": {
  "title": "Predator League Tongue TF Halı Saha Ayakkabısı",
  "color": "Beyaz",
  "brand": "adidas",
  "url": "https://kixz.com/predator-league-tongue-tf-hali-saha-ayakkabisi-beyaz-js4853",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/9f516d23-2e90-4a84-b630-430e5ffcee25/image_1080.webp",
  "price": 3959.4,
  "listPrice": 6599.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/JS4853_0_600.jpg"
 },
 "F50_TF": {
  "title": "F50 League TF Halı Saha Ayakkabısı",
  "color": "Sarı",
  "brand": "adidas",
  "url": "https://kixz.com/f50-league-tf-hali-saha-ayakkabisi-sari-jr8978",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/386aa6dd-d6ba-4434-945a-de89089ba309/image_1080.webp",
  "price": 3239.4,
  "listPrice": 5399.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/JR8978_0_600.jpg"
 },
 "K_VINI": {
  "title": "Mercurial Vapor 16 Academy Vini Jr. FG/MG Çocuk Krampon",
  "color": "Kırmızı",
  "brand": "Nike",
  "url": "https://kixz.com/zoom-mercurial-vapor-16-academy-vini-jr-fg-mg-cocuk-krampon-kirmizi-im3650-640",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/016e1b9e-b0ff-4db3-90e3-6475ada52bdf/image_1080.webp",
  "price": 2729.3,
  "listPrice": 3899.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IM3650-640_0_600.jpg"
 },
 "K_SF": {
  "title": "Mercurial Superfly 10 Academy NU3 FG/MG Çocuk Krampon",
  "color": "Bordo",
  "brand": "Nike",
  "url": "https://kixz.com/mercurial-superfly-10-academy-nu3-fg-mg-cocuk-krampon-bordo-io8468-661",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/e80102e2-b452-4d80-8f16-2fdac81c5172/image_1080.webp",
  "price": 3279.2,
  "listPrice": 4099.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IO8468-661_0_600.jpg"
 },
 "K_TM": {
  "title": "Tiempo Maestro Academy MG Çocuk Krampon",
  "color": "Beyaz",
  "brand": "Nike",
  "url": "https://kixz.com/tiempo-maestro-academy-mg-cocuk-krampon-beyaz-ib5026-146",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/386b989e-6893-4c16-843c-f183ed47eba2/image_1080.webp",
  "price": 2339.35,
  "listPrice": 3599.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IB5026-146_0_600.jpg"
 },
 "K_PH": {
  "title": "Phantom 6 High Academy FG/MG Çocuk Krampon",
  "color": "Pembe / Beyaz",
  "brand": "Nike",
  "url": "https://kixz.com/phantom-6-high-academy-fg-mg-cocuk-krampon-pembe-beyaz-ih1789-901",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/b5ae815b-a085-43d1-ad3d-b01c52461b52/image_1080.webp",
  "price": 3074.25,
  "listPrice": 4099.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IH1789-901_0_600.jpg"
 },
 "BAR_H": {
  "title": "Barcelona 2026/27 İç Saha Taraftar Forma",
  "color": "",
  "brand": "Nike",
  "url": "https://kixz.com/barcelona-2026-27-ic-saha-taraftar-forma-ii1872-683",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/35af7b1e-22df-443d-8aea-a1b6861dc3e5/image_1080.webp",
  "price": 6099.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/II1872-683_0_600.jpg"
 },
 "BAR_3": {
  "title": "Barcelona 2026/27 Üçüncü Taraftar Forma",
  "color": "Turkuaz",
  "brand": "Nike",
  "url": "https://kixz.com/barcelona-2026-27-ucuncu-taraftar-forma-turkuaz-ii6652-301",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/9f038ae0-dbfb-497e-aaca-5ecd50f6b33f/image_1080.webp",
  "price": 6599.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/II6652-301_0_600.jpg"
 },
 "BAR_K": {
  "title": "Barcelona 2026/27 İç Saha Çocuk Forma",
  "color": "Mavi / Kırmızı",
  "brand": "Nike",
  "url": "https://kixz.com/barcelona-2026-27-ic-saha-cocuk-forma-mavi-kirmizi-ii1624-683",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/6f26db7e-6e6a-4838-9c7b-2205eba507a4/image_1080.webp",
  "price": 5099.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/II1624-683_0_600.jpg"
 },
 "BAR_T": {
  "title": "Barcelona 2026/27 Kolsuz Antrenman Üstü",
  "color": "Mor",
  "brand": "Nike",
  "url": "https://kixz.com/barcelona-2026-27-kolsuz-antrenman-ustu-mor-iv6199-505",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/7c6276a2-0488-476d-b6cd-2fbe21fa2abd/image_1080.webp",
  "price": 4499.0,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/IV6199-505_0_600.jpg"
 },
 "PH6_HA": {
  "title": "Phantom 6 High Academy FG Krampon",
  "color": "Mavi",
  "brand": "Nike",
  "url": "https://kixz.com/phantom-6-high-academy-fg-krampon-mavi-hq2278-446",
  "image": "https://cdn.myikas.com/images/dee1ce8a-0827-4882-a9cd-1b2a74d0d2e4/ae3a1dfb-ef44-4082-b136-22b2847e5b01/image_1080.webp",
  "price": 3179.4,
  "listPrice": 5299.0,
  "jpg": "https://api.glowytics.com/pixel/kixz-email/img/HQ2278-446_0_600.jpg"
 }
};
export default PR;
